import { DataSource } from '@angular/cdk/table';
import { inject } from '@angular/core';
import { EmployeeBudgetDataAccessService } from '@flexyoo/employee/data-access';
import { EmployeeBudgetSummary } from '@flexyoo/employee/models';
import {
  DataSourceState,
  DataSourceStateProvider,
} from '@flexyoo/shared/models';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from '@flexyoo/auth';

export class EmployeeBudgetCurrentYearListDataSource
  extends DataSource<EmployeeBudgetSummary>
  implements DataSourceStateProvider
{
  private auth = inject(AuthenticationService);
  private dataAccessService = inject(EmployeeBudgetDataAccessService);
  private refresh$ = new BehaviorSubject(null);
  private _state$ = new BehaviorSubject<DataSourceState>('loading');
  state$ = this._state$.asObservable();

  private result$ = combineLatest([
    this.auth.currentUserSubject,
    this.refresh$,
  ]).pipe(
    tap(() => {
      this._state$.next('loading');
    }),
    switchMap(([user]) =>
      this.dataAccessService.getEmployeeCurrentYearBudgets(user.EmployeeId)
    ),
    tap(() => {
      this._state$.next('loaded');
    }),
    shareReplay(1)
  );

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<EmployeeBudgetSummary[]> {
    return this.result$;
  }

  disconnect() {}
}
